module.exports = __webpack_public_path__ + "img/circle.af935584.png";